import { useEffect, useState } from "react";
import {
  Table,
  ScrollArea,
  Card,
  Button,
  Modal,
  LoadingOverlay,
  Grid,
  createStyles,
  Text,
  Stack,
  Select,
  Group,
} from "@mantine/core";
import { ManualGearbox } from "tabler-icons-react";
import { useForm } from "@mantine/form";
import Map from "components/utilities/Map";
import { useQuery, useMutation } from "@apollo/client";
import { showNotification } from "@mantine/notifications";
import { customLoader } from "components/utilities/loader";
import {
  GET_ORDER,
  GET_PRODUCT,
  GET_RETAILER,
  GET_SHIPMENTS,
} from "apollo/queries";
import { SHIP_ITEM } from "apollo/mutuations";
import { useViewportSize } from "@mantine/hooks";
import { Box } from "@mui/material";
import { formatNumber, formatStatus } from "utiles/url";

const useStyles = createStyles((theme) => ({
  root: {
    padding: theme.spacing.xl * 1.5,
  },

  value: {
    fontSize: 17,
    fontWeight: 500,
    lineHeight: 1,
  },

  diff: {
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
  },

  icon: {
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[3]
        : theme.colors.gray[4],
  },

  title: {
    fontWeight: 700,
    textTransform: "uppercase",
  },
}));
function RetailerDetailModal({ Id }) {
  // state variables
  const [retailer, setRetailer] = useState();
  const { classes } = useStyles();

  const { loading: retailerLoading, refetch } = useQuery(GET_RETAILER, {
    variables: { id: Id },
    onCompleted(data) {
      let retailer = data.retailer;
      setRetailer(retailer);
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message: error?.graphQLErrors?.[0]?.message || "Failed to get retailer",
      });
    },
  });
  useEffect(() => {
    refetch();
  }, []);

  const { height } = useViewportSize();

  return (
    <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
      <div style={{ width: "98%", margin: "auto" }}>
        <LoadingOverlay
          visible={retailerLoading}
          color="blue"
          overlayBlur={2}
          loader={customLoader}
        />
        <Card style={{ marginTop: "10px" }} shadow="sm" p="lg">
          <ScrollArea>
            <div>
              <Text size="md" weight={500} className={classes.diff}>
                <span style={{ fontSize: 17, fontWeight: 500 }}>Orders</span>
              </Text>
              <Table
                horizontalSpacing="md"
                verticalSpacing="xs"
                sx={{ tableLayout: "fixed", minWidth: 600 }}
              >
                <thead>
                  <tr>
                    <th>Order Code</th>
                    <th>Warehouse</th>
                    <th>Total Price</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {retailer?.orders.length > 0 ? (
                    <>
                      {retailer?.orders?.map((item) => (
                        <tr key={item.id}>
                          <td>{item.order_code}</td>
                          <td>{item.warehouse.name}</td>
                          <td>{formatNumber(item.total_price)}</td>
                          <td>{formatStatus(item.status)}</td>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={3}>
                        <Text weight={500} align="center">
                          Nothing Found Orders
                        </Text>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </ScrollArea>
        </Card>
      </div>
    </ScrollArea>
  );
}

export default RetailerDetailModal;
